/** Must match apps/api/src/lib/orderPricing.ts */
export const FREE_SHIPPING_THRESHOLD_CENTS = 200000; // 2000 MXN
